import { Link } from 'react-router';

import { cn } from '@/shared/utils/cn';

import { SparkIcon } from './icons';

/**
 * The one sentence the AI Act asks for (Reglamento (UE) 2024/1689, artículo 50; adenda,
 * cláusula 8.3): people using the tool know that what they are looking at was produced
 * by an AI and that a person checks it before it has any effect.
 *
 * Permanent and discreet, on purpose: one line of 12 px in the quietest ink, meant for
 * the foot of the page (`mt-auto`) or right under the card the AI produced, every time,
 * without a dismiss button. A notice that can be closed is a notice that was closed on
 * the first day; a notice that takes three lines above the content is one that gets
 * scrolled past without reading. Small and always there beats big and gone.
 */
export const AI_NOTICE =
  'Propuesta generada por inteligencia artificial. Una persona la revisa antes de que tenga efecto.';

export function AiNotice({ className }: { className?: string }) {
  return (
    <p
      className={cn(
        'text-ink-4 flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-[12px] leading-snug',
        className,
      )}
    >
      <SparkIcon size={12} className="shrink-0" />
      <span>{AI_NOTICE}</span>
      <Link to="/acerca-de" className="text-ink-3 underline underline-offset-2 hover:text-ink">
        Qué hace la IA y qué no
      </Link>
    </p>
  );
}
